var Services = (function($) {
  function initExpandableServices() {
    $(".services-item__list-item--expandable").on("click", function() {
      const $clicked = $(this);

      // Cerrar todas menos la clicada
      $(".services-item__list-item--expanded")
        .not($clicked)
        .removeClass("services-item__list-item--expanded");

      // Toggle solo en la clicada
      $clicked.toggleClass("services-item__list-item--expanded");
    });
  }

  function initExpandableProducts() {
    $(".products-list__item--expandable").on("click", function() {
      const $clicked = $(this);

      // Cerrar todas menos la clicada
      $(".products-list__item--expanded")
        .not($clicked)
        .removeClass("products-list__item--expanded");

      // Toggle solo en la clicada
      $clicked.toggleClass("products-list__item--expanded");
    });
  }

  function init() {
    if (!$(".services").length) return;
    initExpandableServices();
    initExpandableProducts();
  }

  return { init };
})(jQuery);

jQuery(document).ready(Services.init);
